/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const LearnIcon = ({ width = 24, height = 24, hidden = false, title = 'Learn' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18.5 7.92a8.11 8.11 0 0 0-8.372 7.84v.54a8.986 8.986 0 0 0 2.57 5.974 5.934 5.934 0 0 1 1.7 3.384v5.182a2 2 0 0 0 .636 1.462l1.53 1.428a1 1 0 0 0 .69.27h2.484a1 1 0 0 0 .682-.27l1.536-1.43c.406-.378.636-.908.634-1.462v-4.6a4.784 4.784 0 0 1 .53-2.312c.7-1.274 1.8-2.286 2.564-3.526a7.77 7.77 0 0 0 1.188-4.096A8.114 8.114 0 0 0 18.5 7.92Zm3.938 12.856a11.446 11.446 0 0 0-1.948 2.988 6.438 6.438 0 0 0-.35 2.218h-3.272a7.07 7.07 0 0 0-.114-1.4 6.014 6.014 0 0 0-.688-1.752 16.58 16.58 0 0 0-1.506-2.066 6.742 6.742 0 0 1-2.04-4.462 5.674 5.674 0 0 1 5.98-5.988 5.678 5.678 0 0 1 5.98 5.986 6.754 6.754 0 0 1-2.042 4.476Z"
    />
    <rect x="17.274" width="2.454" height="5.728" rx=".409" ry=".409" />
    <rect x="29.136" y="15.546" width="5.728" height="2.454" rx=".409" ry=".409" />
    <rect x="2.136" y="15.546" width="5.728" height="2.454" rx=".409" ry=".409" />
    <rect
      x="6.27"
      y="4.691"
      width="2.454"
      height="5.726"
      rx=".409"
      ry=".409"
      transform="rotate(-45 7.497 7.554)"
    />
    <rect
      x="26.635"
      y="6.327"
      width="5.726"
      height="2.454"
      rx=".409"
      ry=".409"
      transform="rotate(-45 29.498 7.554)"
    />
  </svg>`;
};
